import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest, Observable, Subject, Subscription } from 'rxjs';
import { takeUntil, take } from 'rxjs/operators';

import * as fromTask from '../../task-state/reducers/task.reducer';
import * as Task from '../../task-state/actions/task.actions';
import { UnsubscribeSubcriptionService } from 'src/app/services/unsubscribe-subcription.service';
import { HelpVideoOverlayComponent } from '../../../../modules/shared/help-video-overlay/help-video-overlay.component';
import { SubTask, SuperTask } from 'app-models';
import * as RolesRouteMap from 'src/app/data/constants/roles';
import { LookupService } from 'src/app/services/lookup-data.service';

@Component({
  selector: 'app-supertask-summary',
  templateUrl: './superTask-summary.component.html',
  styleUrls: ['./superTask-summary.component.scss']
})
// export class SuperTaskSummaryComponent implements OnInit, OnDestroy, AfterViewInit {
export class SuperTaskSummaryComponent implements OnInit, OnDestroy {
  summaryStatus = 'new';
  subTaskList: SubTask[];
  superTaskId;
  index = 0;
  isSuperTaskAvailable$: Observable<boolean>;
  disableRfe = false;
  displayDialog = false;
  permAccessible = false;
  superTaskDetails: SuperTask;
  subscriptions: Subscription[] = [];
  observableSubscription$ = new Subject();
  userType: string;
  @ViewChild(HelpVideoOverlayComponent, { static: false }) helpVideoComponent: HelpVideoOverlayComponent;
  isSimplify: boolean;
  isFromBulkUpload: any = false;
  isVisaDesignedByVdTemplate: any;

  constructor(
    private route: ActivatedRoute,
    private store: Store<fromTask.State>,
    private router: Router,
    private unsubscribeSubscriptionService: UnsubscribeSubcriptionService,
    private lookupService: LookupService,
    // private utilityService: TaskUtilityService
  ) {
    this.userType = sessionStorage.getItem('userTypeRole');
  }

  ngOnInit() {
    setTimeout(() => {
      if (sessionStorage.getItem('isSimplify') && sessionStorage.getItem('isSimplify') == 'CWF') {
        this.isSimplify = true;
      } else {
        this.isSimplify = false;
      }
    }, 1000);

    this.subscriptions[this.subscriptions.length] = this.store.select(fromTask.getActiveTabIndex).subscribe(tabIndex => {
      this.index = tabIndex;
    });
    this.subscriptions[this.subscriptions.length] = this.route.data.subscribe((data) => {
      if (data.taskDetails) {
        this.getSuperTaskDetails(data.taskDetails);
      }
    });
    // const navigation = this.router.getCurrentNavigation();
    // console.log('here--', navigation);
    // if (navigation?.extras.state) {
    //   this.isFromBulkUpload = navigation.extras.state.fromBulkUpload;
    //   console.log('here111--', this.isFromBulkUpload)
    // }
    this.isFromBulkUpload = sessionStorage.getItem('fromBulkUpload');
  }

  // ngAfterViewInit() {
  //   this.helpVideoComponent.setTabValues(
  //     'right',
  //     'How to build a H-1B petition',
  //     'Part 1 How to Build a H-1B Petition',
  //     'Part 1 How to Build a H-1B Petition',
  //     'right',
  //     'Part 2 How to Build a H-1B Petition',
  //     'Part 2 How to Build a H-1B Petition'
  //   );
  // }


  getSuperTaskDetails(taskDetails) {
    this.store.dispatch(new Task.SetTaskSummaryOverview(taskDetails));
    this.isSuperTaskAvailable$ = this.store.select(fromTask.getIsSuperTask);
    // this.superTaskDetails = taskDetails.superTask;
    combineLatest([
      this.store.select(fromTask.getSubTaskList),
      this.store.select(fromTask.getSuperTask)
    ])
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe(([subTaskList, superTask]) => {
        if (superTask && superTask.superTaskId) {
          this.disableRfe = false;
          this.superTaskDetails = superTask;
          this.superTaskId = this.superTaskDetails.superTaskId;
          let taskType = superTask.visaType ? superTask.visaType.code : superTask.immigrationType ? superTask.immigrationType.code : subTaskList[0].taskTypeCode;
          if (subTaskList) {
            this.subTaskList = subTaskList;
            this.isVisaDesignedByVdTemplate = !!(subTaskList[0]?.taskTypeSaveJsonId);
            sessionStorage.setItem('tempBeneficiaryEmployeeId', sessionStorage.getItem('beneficiaryId'));
            sessionStorage.setItem('taskDetailsList', JSON.stringify(this.subTaskList));
            this.subTaskList.forEach((item) => {
              item['imgPath'] = "assets/images/" +
                (["PWDEFILE"].includes(item.taskTypeCode) ?
                  "Prevailing Wage Determination_icon.png" :
                  ((item.taskTypeCode !== "PERM" ? item.taskTypeName : "Perm") + "_icon.png"));
              if (!['I485'].includes(item.taskTypeCode)) {
                if (item.statusCode === 'FILED') {
                  this.summaryStatus = 'filed';
                }
                else if (item.statusCode === 'INPROGRESS') {
                  this.summaryStatus = 'inprogress';
                }
                else if (item.statusCode === 'APPROVED') {
                  this.summaryStatus = 'completed';
                }
                if (item.taskTypeCode === 'PETITION' && item.isOutside) {
                  item.stepOverviewList.forEach((element) => {
                    if (element.layoutCode !== 'WAIT' && element.stepStatusCode !== 'COMPLETE') {
                      this.disableRfe = true;
                      this.summaryStatus = 'inprogress';
                      if (element.stepStatusCode === 'NEW') {
                        this.summaryStatus = '';
                      }
                    }
                  });
                }
              }
              switch (item.taskTypeCode) {
                case 'PETITION':
                  item.visaTypeName = this.superTaskDetails.visaType ?
                    this.superTaskDetails.visaType?.name :
                    this.superTaskDetails.immigrationCategory?.name;
                  item.immigrationFamilyBased = this.superTaskDetails?.immigrationClassification?.code;
                  if (item.statusCode === 'APPROVED') {
                    item.summaryBorderClassName = 'completed';
                  } else if (['INPROGRESS', 'FILED', 'DENIED', 'RFEISS', 'WITHDRAWN'].includes(item.statusCode)) {
                    item.summaryBorderClassName = 'inprogress';
                  } else {
                    item.summaryBorderClassName = '';
                  }
                  break;
                case 'PWD':
                  if (item.statusCode === 'PWDISSUED') {
                    item.summaryBorderClassName = 'completed';
                  } else if (['INPROGRESS', 'PWDREQUESTED', 'PWDNOTISSUED'].includes(item.statusCode)) {
                    item.summaryBorderClassName = 'inprogress';
                  } else {
                    item.summaryBorderClassName = '';
                  }
                  break;
                case 'RECEFF':
                  if (item.statusCode === 'COMPLETED') {
                    item.summaryBorderClassName = 'completed';
                  } else if (item.statusCode === 'INPROGRESS') {
                    item.summaryBorderClassName = 'inprogress';
                  } else {
                    item.summaryBorderClassName = '';
                  }
                  break;
                case 'PERM':
                  if (item.statusCode === 'CERTIFIED') {
                    item.summaryBorderClassName = 'completed';
                  } else if (['INPROGRESS', 'FILED', 'DENIED', 'AUDITNOTCISS', 'CERTEXPIRED', ''].includes(item.statusCode)) {
                    item.summaryBorderClassName = 'inprogress';
                  } else {
                    item.summaryBorderClassName = '';
                  }
                  if (this.subTaskList.find(subTask => subTask.taskTypeCode === 'PWD').statusCode === 'PWDISSUED' &&
                    this.subTaskList.find(subTask => subTask.taskTypeCode === 'RECEFF').statusCode === 'COMPLETED') {
                    this.permAccessible = true;
                  } else {
                    this.permAccessible = false;
                  }
                  break;
                case 'I140':
                case 'I485':
                  if (item.statusCode === 'APPROVED') {
                    item.summaryBorderClassName = 'completed';
                  } else if (['INPROGRESS', 'FILED', 'DENIED', 'RFEISS', 'WITHDRAWN'].includes(item.statusCode)) {
                    item.summaryBorderClassName = 'inprogress';
                  } else {
                    item.summaryBorderClassName = '';
                  }
                  break;
                case 'PWDEFILE':
                case 'I130ONLINEEFILE':
                  item.summaryBorderClassName = '';
                  break;
              }
            });
          }
        }
      });
  }

  handleChange(e) {
    this.index = e.index;
    if (this.index > 0) {
      switch (this.subTaskList[this.index - 1].taskTypeCode) {
        case 'PETITION':
          //case "I140":
          if (this.superTaskDetails.visaType) {
            this.router.navigate([`./visa/${this.superTaskDetails.visaType?.code}`], { relativeTo: this.route });
          } else {
            this.router.navigate([`./visa/${this.superTaskDetails.immigrationCategory?.code}`], { relativeTo: this.route });
          }
          break;
        case 'RFE':
          if (this.disableRfe) {
            this.displayDialog = true;
          } else {
            this.store.dispatch(new Task.SetRFEIndex(this.index - 1));
            this.router.navigate([`./rfe`], { relativeTo: this.route });
          }
          break;
        case 'PWD':
          this.router.navigate([`./green-card/pwd`], { relativeTo: this.route });
          break;
        case 'RECEFF':
          this.router.navigate([`./green-card/re`], { relativeTo: this.route });
          break;
        case 'PERM':
          //if (this.permAccessible) { IM-21087 removing PERM disabled condition
          this.router.navigate([`./green-card/perm`], { relativeTo: this.route });
          //}
          break;
        case 'I140':
          // if (this.isVisaDesignedByVdTemplate || ['EB2NIWSELFSPO', 'EB2NIWSSPONSOR'].includes(this.superTaskDetails.immigrationClassification?.code)) {
          if (this.isVisaDesignedByVdTemplate) {
            this.router.navigate([`./visa/${this.superTaskDetails.immigrationCategory?.code}`], { relativeTo: this.route });
          } else {
            this.router.navigate([`./I-140/details`], { relativeTo: this.route });
          }

          break;
        case 'I130':
        case 'I485':
        case 'DS260':
        case 'DS160':
        case 'PWDEFILE':
        case 'I129EFILING':
        case 'I130ONLINEEFILE':
          this.router.navigate([`./immigration/${this.subTaskList[this.index - 1].taskTypeCode}`], { relativeTo: this.route });
          break;
        default:
          this.router.navigate([`./summary`], { relativeTo: this.route });
          break;
      }
    } else {
      this.router.navigate([`./summary`], { relativeTo: this.route });
    }
  }
  backToBulkUpload() {
    this.router.navigate([`${RolesRouteMap.userRoleRouteMapping[localStorage.getItem('userTypeRole')]}/bulk-upload`]);
  }

  ngOnDestroy(): void {
    sessionStorage.removeItem('fromBulkUpload');
    this.store.dispatch(new Task.SetTaskSummaryOverview(null));
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
    this.unsubscribeSubscriptionService.onUnSubscribe(this.subscriptions);
  }

}
